import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Button } from '../Button';
export const PillButton = styled(({ variant = 'tertiary', size = 'small', borderless = true, ...props }) => {
    return _jsx(Button, { variant: variant, size: size, borderless: borderless, ...props });
}) `
  border-radius: ${o => o.theme.spacing(5)};
  padding: ${o => o.theme.spacing(0, 2)};
  transition: 0.3s background-color;
`;
//# sourceMappingURL=index.js.map